import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';
import { FileResponse } from '../modules/tcm-core.module/models/files/file-response';

@Injectable({
  providedIn: 'root'
})
export class FilesDataService {

  constructor(private httpClient: ApiHttpClient) {
  }

  public async downloadAndSaveDocumentFileAsync(id: number | string): Promise<any> {
    try {
      var fileResponse = await this.downloadDocumentFileBlobAsync(id, false);
      
      fileResponse.save();
    }
    catch (e) {

    }
  }

  public async downloadAndSaveLogFileAsync(id: number | string): Promise<any> {
    try {
      var fileResponse = await this.downloadDocumentFileBlobAsync(id, true);

      fileResponse.save();      
    }
    catch (e) {

    }
  }

  private downloadDocumentFileBlobAsync(id: number | string, isLogFile: boolean): Promise<FileResponse> {
    return this.httpClient.getFileAsync(`files/${isLogFile ? 'downloadLog' : 'download'}?id=${id.toString()}`);
  }

  public async downloadAndSaveErrorLogFileAsync(id: number): Promise<any> {
    try {
      var fileResponse = await this.httpClient.getFileAsync(`files/downloadErrorLog?id=${id}`);
      fileResponse.save();      
    }
    catch (e) { }
  }

  async downloadAndDisplayFileAsync(id: number | string): Promise<any> {
    try {
      var fileResponse = await this.downloadFileBlobAsync(id);
      await fileResponse.displayFileAsync();
    }
    catch (e) { }
  }

  private downloadFileBlobAsync(id: number | string): Promise<FileResponse> {
    return this.httpClient.getFileAsync(`files/download?id=${id.toString()}`);
  }

}
